import type { ActionsOfCreators, FeatureHandler } from '../helpers';
import { started } from './startedAction';

export const outputActions = [started];

export type OutputActions = ActionsOfCreators<typeof outputActions>;

export type Handler<T extends OutputActions> = FeatureHandler<T, OutputActions>;
